/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Action for the component SuperSearch
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.0
 */
import { createAction } from '../app/createAction';
import {
    SUPER_SEARCH_CHANGE,
    SUPER_SEARCH_CLEAR,
    SUPER_SEARCH_EMPTY,
    SUPER_SEARCH_FAILED,
    SUPER_SEARCH_START,
    SUPER_SEARCH_SUCCESSFUL,
    SUPER_SEARCH_TOGGLE,
} from './superSearchConstants';
import {
    ISuperSearch,
    TSuperSearchChange,
    TSuperSearchClear,
    TSuperSearchEmpty,
    TSuperSearchFailed,
    TSuperSearchStart,
    TSuperSearchSuccessful,
    TSuperSearchToggle,
} from './superSearchTypes';

export const superSearchStart = (): TSuperSearchStart =>
    createAction(SUPER_SEARCH_START);
export const superSearchSuccessful = (payload: ISuperSearch): TSuperSearchSuccessful =>
    createAction(SUPER_SEARCH_SUCCESSFUL, payload);
export const superSearchEmpty = (): TSuperSearchEmpty =>
    createAction(SUPER_SEARCH_EMPTY);
export const superSearchFailed = (payload: string): TSuperSearchFailed =>
    createAction(SUPER_SEARCH_FAILED, payload);
export const superSearchClear = (): TSuperSearchClear =>
    createAction(SUPER_SEARCH_CLEAR);
export const superSearchChange = (payload: string): TSuperSearchChange =>
    createAction(SUPER_SEARCH_CHANGE, payload);
export const superSearchToggle = (payload: boolean): TSuperSearchToggle =>
    createAction(SUPER_SEARCH_TOGGLE, payload);

export type SuperSearchTypes =
    TSuperSearchChange
    | TSuperSearchClear
    | TSuperSearchEmpty
    | TSuperSearchFailed
    | TSuperSearchStart
    | TSuperSearchSuccessful
    | TSuperSearchToggle;
